import { AUTH_ACTION as types } from '../../constants/auth';

const initialState = {
  token: null,
  user: {},
  loginID: '',
  isAuthenticated: false,
  isVerifiedAccount: false,
  tradingAccount: [],
  lastLoginTime: '',
  aastockClientId:'',
  username: ''
}

export const authReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN:
      return Object.assign({}, state, {
        isAuthenticated: action.isAuthenticated,
        loginID: action.loginID || state.loginID,
        isVerifiedAccount: action.isVerifiedAccount,
        tradingAccount: action.tradingAccount || state.tradingAccount,
        user: action.user || state.user,
        token: action.token || state.token,
        lastLoginTime: action.lastLoginTime || state.lastLoginTime,
        username: action.username || state.username,
        aastockClientId:action.aastockClientId || state.aastockClientId,
      });
    case types.LOGOUT:
      return Object.assign({}, state, {
        isAuthenticated: action.isAuthenticated,
        loginID: action.loginID || state.loginID,
        isVerifiedAccount: action.isVerifiedAccount,
        user: action.user || state.user,
        token: action.token,
        tradingAccount: action.tradingAccount || state.tradingAccount
      });
    case types.ACTIVE_ACCOUNT:
      return Object.assign({}, state, {
        isVerifiedAccount: action.isVerifiedAccount
      });
    default:
      return state
  }
}
